'use client';

import { styled } from 'styled-components';

const SplitCardsGrid = styled.div`
  display: grid;
  gap: ${({ theme }) => `${theme.spacing['0.75']} ${theme.spacing['1']}`};
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: auto;
  padding-top: ${({ theme }) => theme.spacing['1.5']};
  text-wrap: balance;

  ${({ theme }) => theme.mq.minWidth.large} {
    padding-top: ${({ theme }) => theme.spacing['2']};
  }
`;

export default SplitCardsGrid;
